import _ 					from "lodash";

// Минимальный ZIP-писатель (метод "store", без сжатия).
// Используется чтобы упаковать папку в один архив на клиенте и отправить её на сервер одним файлом.
// Сжатия нет намеренно: клиент проверяет размер папки без сжатия (лимит 100 МБ задаётся в сервисе File).
let FileZip = {

	// Таблица для расчёта CRC32
	CRC_TABLE: (() => {

		let table = new Array(256);

		for (let n = 0; n < 256; n++) {

			let c = n;

			for (let k = 0; k < 8; k++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);

			table[n] = c >>> 0;

		}

		return table;

	})(),

	crc32(bytes) {

		let crc = 0xFFFFFFFF;

		for (let i = 0; i < bytes.length; i++) crc = (crc >>> 8) ^ this.CRC_TABLE[(crc ^ bytes[i]) & 0xFF];

		return (crc ^ 0xFFFFFFFF) >>> 0;

	},

	// Побайтовые значения даты и времени в формате DOS (нужны для заголовков zip)
	getDosDateTime() {

		let now = new Date();

		let time = (now.getHours() << 11) | (now.getMinutes() << 5) | (now.getSeconds() >> 1);
		let date = ((now.getFullYear() - 1980) << 9) | ((now.getMonth() + 1) << 5) | now.getDate();

		return {time: time & 0xFFFF, date: date & 0xFFFF};

	},

	// Создаём Blob с zip-архивом. entries: [{name: "folder/file.txt", data: Uint8Array}]
	create(entries) {

		let encoder = new TextEncoder();
		let dos = this.getDosDateTime();

		let chunks = [];
		let central = [];
		let offset = 0;

		_.each(entries, entry => {

			let nameBytes = encoder.encode(entry.name);
			let data = entry.data instanceof Uint8Array ? entry.data : new Uint8Array(entry.data);
			let size = data.length;
			let crc = this.crc32(data);

			// Локальный заголовок файла (30 байт) + имя
			let local = new Uint8Array(30 + nameBytes.length);
			let view = new DataView(local.buffer);

			view.setUint32(0, 0x04034b50, true);
			view.setUint16(4, 20, true);
			view.setUint16(6, 0, true);
			view.setUint16(8, 0, true);
			view.setUint16(10, dos.time, true);
			view.setUint16(12, dos.date, true);
			view.setUint32(14, crc, true);
			view.setUint32(18, size, true);
			view.setUint32(22, size, true);
			view.setUint16(26, nameBytes.length, true);
			view.setUint16(28, 0, true);
			local.set(nameBytes, 30);

			chunks.push(local, data);

			// Запись центрального каталога (46 байт) + имя
			let centralHeader = new Uint8Array(46 + nameBytes.length);
			let cview = new DataView(centralHeader.buffer);

			cview.setUint32(0, 0x02014b50, true);
			cview.setUint16(4, 20, true);
			cview.setUint16(6, 20, true);
			cview.setUint16(8, 0, true);
			cview.setUint16(10, 0, true);
			cview.setUint16(12, dos.time, true);
			cview.setUint16(14, dos.date, true);
			cview.setUint32(16, crc, true);
			cview.setUint32(20, size, true);
			cview.setUint32(24, size, true);
			cview.setUint16(28, nameBytes.length, true);
			cview.setUint16(30, 0, true);
			cview.setUint16(32, 0, true);
			cview.setUint16(34, 0, true);
			cview.setUint16(36, 0, true);
			cview.setUint32(38, 0, true);
			cview.setUint32(42, offset, true);
			centralHeader.set(nameBytes, 46);

			central.push(centralHeader);

			offset += local.length + data.length;

		});

		let centralSize = _.sumBy(central, chunk => chunk.length);

		// Конец центрального каталога (22 байта)
		let eocd = new Uint8Array(22);
		let eview = new DataView(eocd.buffer);

		eview.setUint32(0, 0x06054b50, true);
		eview.setUint16(4, 0, true);
		eview.setUint16(6, 0, true);
		eview.setUint16(8, entries.length, true);
		eview.setUint16(10, entries.length, true);
		eview.setUint32(12, centralSize, true);
		eview.setUint32(16, offset, true);
		eview.setUint16(20, 0, true);

		return new Blob(chunks.concat(central, [eocd]), {type: 'application/zip'});

	},

	// Человекочитаемый размер для сообщений об ошибке
	formatSize(bytes) {

		bytes = bytes || 0;

		if (bytes < 1024) return `${bytes} B`;

		let units = ['KB', 'MB', 'GB', 'TB'];
		let value = bytes / 1024;
		let index = 0;

		while (value >= 1024 && index < units.length - 1) {

			value /= 1024;
			index++;

		}

		return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[index]}`;

	}

};

export { FileZip };
